import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// MUI Icons
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";


const MapRouteBoxNoRoute = () => {

  const { t } = useTranslation();

  return (
    <Box p={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="flex-start"
        >
          <Typography variant="h6" color="primary" textAlign="center">
            {t("notifications.no_route_found")}{" "}
          </Typography>
          <Typography variant="body1" color="primary" textAlign="center">
            {t("notifications.correct_points")}{" "}
          </Typography>
        </Box>
        <SentimentVeryDissatisfiedIcon
          fontSize="large"
          color="primary"
        />
      </Box>
    </Box>
  );
}

export default MapRouteBoxNoRoute;
